import React, { useEffect } from "react";

import { useDispatch } from "react-redux";

import { setUiDrawer } from "@app/state";
import { Icon } from "@iconify/react";

import "./closeButton.scss";

export const InsidersCloseButton = ({
  toggleDrawer,
}: {
  toggleDrawer: (bool?: boolean) => void;
}) => {
  const dispatch = useDispatch();
  const closeDrawer = () => {
    dispatch(setUiDrawer({ currentPage: "profile" }));
    toggleDrawer(false);
  };

  return (
    <Icon
      id={"jg-close"}
      icon="line-md:close-small"
      color="#245ca0"
      width="24"
      onClick={closeDrawer}
    />
  );
};
